module.exports = {"621102001":"中华路街道","621102002":"永定路街道","621102003":"福台路街道","621102101":"凤翔镇","621102102":"内官营镇","621102103":"巉口镇","621102104":"称钩驿镇","621102105":"鲁家沟镇","621102106":"西巩驿镇","621102107":"宁远镇","621102108":"李家堡镇","621102109":"团结镇","621102110":"香泉镇","621102111":"符家川镇","621102112":"葛家岔镇","621102204":"白碌乡","621102207":"石峡湾乡","621102208":"新集乡","621102209":"青岚山乡","621102210":"高峰乡","621102211":"石泉乡","621102214":"杏园乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621102.json
// module id = 3086
// module chunks = 0